import { render } from "./DTableRow.vue?vue&type=template&id=2e8ddfa8"
import script from "./DTableRow.vue?vue&type=script&lang=js"
export * from "./DTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__